// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"112":"353eb9a8","165":"23b8e4a6","270":"e7ad068b","737":"39b66f46","873":"ecb762a8"}[chunkId] + ".css";
};